<script lang="ts">
    import Calendar from "../../components/formComponents/Calendar.svelte"

    export let field: TaskStepField<"dateTime">,
        value: Date = null
    if (value) value = new Date(value)
</script>

<Calendar
    placeholder="{field.label || 'Start'}"
    id="{field.name}"
    bind:dateValue="{value}"
/>

<style lang="less"></style>
